// This is just an example,
// so you can safely delete all default props below

export default {
  attendance: 'Présence',
  absent: 'Absent',
  basic: 'De base',
  catalog: 'Catalogue',
  Center: 'Centre',
  centers: 'Centres',
  color: 'Couleur',
  communicate: 'Communication',
  discounts: 'Remises',
  displayOptions: "Options d'affichage",
  attendanceDisplayMode: "Mode d'affichage de la présence",
  activityIsLinked: "Liée à d'autres activités",
  untitled: 'Sans titre',
  unlinkActivity: 'Dissocier',
  updateAllLinkedActivities:
    "Mettre à jour l'activité et les {count} activités liées",
  linkedActivityTooltip:
    'Activité liée — cliquez pour mettre en évidence ses copies',
  lessonPlanDisplayMode: "Mode d'affichage du plan de leçon",
  cleanDisplayMode: 'Vue épurée',
  cleanDisplayModeShort: 'Épuré',
  detailedDisplayMode: 'Vue détaillée',
  detailedDisplayModeShort: 'Détail',
  recentlySignedIn: 'Présences récentes',
  desc: 'Description',
  exportPortableRecord: 'Exporter le dossier portable',
  exportPortableRecordDescription:
    'Téléchargez un PDF du dossier portable de ce membre du personnel sans la rémunération ni le NAS.',
  families: 'Familles',
  finances: 'Finance',
  groups: 'Groupe',
  groupByStaff: 'Regrouper par personnel',
  groupCapacity: 'Capacité du groupe',
  groupEndDate: 'Date de fin du groupe',
  groupStartDate: 'Date de début du groupe',
  locations: 'Emplacements',
  locationMessagesGroup: {
    inUseError:
      "Impossible de supprimer les emplacements en cours d'utilisation",
  },
  main: 'Principal',
  messages: {
    errors: {},
    success: 'Success',
  },
  name: 'Nom',
  organization: 'Organisation',
  programs: 'Programme',
  present: 'Présent',
  pods: 'Pods',
  pod: 'Pod',
  podMessagesGroup: {
    inUseError:
      "Impossible de supprimer les groupes de transport en cours d'utilisation",
  },
  rates: 'Taux',
  schedules: 'Calendrier',
  schoolMessagesGroup: {
    inUseError: "Impossible de supprimer les écoles en cours d'utilisation",
  },
  setup: 'Configurer',
  spaces: 'Espace',
  sponsors: 'Sponsors',
  sponsorSelection: 'Sélection de sponsor',
  Staff: 'Personnel',
  tasks: 'Tâches',
  theme: 'Thème',
  totals: 'Totaux',
  type: 'Taper',
  transport: 'Transport',
  schools: 'écoles',
  agreementsSignedReport: 'Accords signés',

  agreementsToTrack: 'Accords à suivre',
  hideChildrenWithAllSelectedAgreementsSigned:
    'Masquer les enfants ayant signé tous les accords sélectionnés',
  signed: 'Signé',
}
